import React, { useRef, useState } from "react"
import { useToggle, useWindowScroll } from "../../../utils/Hooks"
import { SinglePathSVG } from "../SVG"
import { RoundedRectangle } from "./roundedrectangle/RoundedRectangle"
import { BodySmall } from "./Bodies"
import { H2 } from "@carrotfertility/carotene"

const AccordionNavigationHeader = ({ handleNavigationOpen, title, subTitle, isOpen }) => (
  <RoundedRectangle backgroundColor="mint-alternate" padding="pa3">
    <div className="flex flex-row justify-between items-center">
      <H2>{title}</H2>
      <div className="flex items-center pointer" onClick={handleNavigationOpen}>
        <BodySmall color="black-80">{subTitle}</BodySmall>
        <div className={`animate-all ml2 pl1 dib carrot-orange ${isOpen ? "rotate-180" : ""}`}>
          <SinglePathSVG icon="rightCarrotLarge" />
        </div>
      </div>
    </div>
  </RoundedRectangle>
)

const AccordionNavigationOverlay = ({ children, containerRef, containerTopPosition, isOpen }) => (
  <div ref={containerRef} className="animate-all relative nr35 nl35">
    {isOpen && (
      <>
        <div className="br3 z-2 absolute top-0 ph35-s right-0 left-0 bg-white pb35 pt3">
          <div className="nh25 ph3 flex flex-wrap">{children}</div>
        </div>
        <div
          className="br3 z-1"
          style={{
            backgroundColor: "rgba(0.1,0.1,0.1,0.3)",
            height: document.body.scrollHeight,
            left: 0,
            position: "fixed",
            right: 0,
            top: containerTopPosition
          }}
        />
      </>
    )}
  </div>
)

export const AccordionNavigation = ({ title, subTitle, children }) => {
  const [containerTopPosition, setContainerTopPosition] = useState(0)
  const [isOpen, toggleIsOpen] = useToggle(false)
  const containerRef = useRef(null)

  const updateContainerPosition = () => {
    setContainerTopPosition(containerRef.current.getBoundingClientRect().top)
  }

  useWindowScroll(updateContainerPosition)

  const handleNavigationOpen = () => {
    updateContainerPosition()
    toggleIsOpen()
  }

  return (
    <>
      <AccordionNavigationHeader
        handleNavigationOpen={handleNavigationOpen}
        title={title}
        subTitle={subTitle}
        isOpen={isOpen}
      />

      <AccordionNavigationOverlay
        containerRef={containerRef}
        containerTopPosition={containerTopPosition}
        isOpen={isOpen}
      >
        {children}
      </AccordionNavigationOverlay>
    </>
  )
}
